// Inertia + React entrypoint for the customer UI rebuild (Atrium).
// Loaded ONLY by the clean-slate `inertia` layout — never by legacy pages,
// so the Tailwind v4 / shadcn world stays fully isolated from the legacy
// Bootstrap + Tailwind-v2 pipeline that `application.js` runs.

import { createInertiaApp } from "@inertiajs/react"
import { createRoot } from "react-dom/client"

// Self-hosted fonts (globals.css wires the families to --font-sans/display).
// Display is Poppins (Stage 4 swap from Space Grotesk); body is Hanken Grotesk.
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/500.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"
import "@fontsource-variable/hanken-grotesk"

import "../styles/globals.css"

import { initTheme } from "../lib/theme"
import { watchPresence } from "../lib/footprintPresence"

// Apply the persisted theme before first paint to avoid a flash.
initTheme()

// A guest start held for a person (the layout's tuw-footprint-presence meta).
watchPresence()

// Vitest specs sit beside their page (pages/Auth/SignIn.test.jsx); they use
// `vi`, which does not exist in the browser, so the eager glob must leave them
// out or the whole bundle throws before mounting.
const pages = import.meta.glob(["../pages/**/*.jsx", "!../pages/**/*.test.jsx"], { eager: true })

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/${name}.jsx`]
    if (!page) throw new Error(`Inertia page not found: ${name}`)
    return page.default ?? page
  },
  setup({ el, App, props }) {
    // A guest discovery page's server-rendered copy, for readers without
    // JavaScript; the app replaces it.
    document.querySelector("[data-static-page]")?.remove()
    createRoot(el).render(<App {...props} />)
  },
})
